import Vue from "vue"
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

Vue.mixin({
  methods: {
    $tcl(path, count) {
      return this.$tc(path, count).toLowerCase()
    },
  }
})

function loadLocaleMessages () {
  const locales = require.context("../locales", true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

let language =
  (window.navigator.languages && window.navigator.languages[0]) ||
  window.navigator.language ||
  window.navigator.userLanguage ||
  window.navigator.browserLanguage
if (language && language.startsWith("ja")) language = "ja"
if (language && language.startsWith("en")) language = "en"
if (language && language.startsWith("pt")) language = "pt"

export default new VueI18n({
  locale: language || process.env.VUE_APP_I18N_LOCALE || "ja",
  fallbackLocale: language || process.env.VUE_APP_I18N_FALLBACK_LOCALE || "ja",
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
})
